import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import {
  COLLAPSIBLE_COUNT_BACKGROUND,
  COLLAPSIBLE_COUNT_FONT_SIZE,
  COLLAPSIBLE_COUNT_HEIGHT,
  COLLAPSIBLE_COUNT_RADIUS_CSS,
  COLLAPSIBLE_COUNT_WIDTH
} from "./collapsible-constants";

const CollapsibleCount = withLiteObserverAndTheme<{ count: number }>(
  (props) => {
    const { count, theme } = props;
    const { colors } = theme;

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={COLLAPSIBLE_COUNT_WIDTH}
        height={COLLAPSIBLE_COUNT_HEIGHT}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={COLLAPSIBLE_COUNT_BACKGROUND}
        style={{ borderRadius: COLLAPSIBLE_COUNT_RADIUS_CSS }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={COLLAPSIBLE_COUNT_FONT_SIZE}
          text={`${count}`}
          isSpan={true}
          color={colors.all.davysGrey}
          style={{}}
        />
      </ET3Div>
    );
  }
);
export default CollapsibleCount;
